import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    firstName: checkRequiredText(settings),
    lastName: checkRequiredText(settings),
    emailAddress: Yup.string()
        .email("Bitte geben Sie eine gültige E-Mail-Adresse an")
        .required("Angabe ist erforderlich"),
});

export const NameSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formFirstName">
                    <Form.Label>Vorname*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Vorname eingeben"
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.firstName && !errors.firstName}
                        isInvalid={touched.firstName && errors.firstName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formLastName">
                    <Form.Label>Name*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Nachname eingeben"
                        type="text"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.lastName && !errors.lastName}
                        isInvalid={touched.lastName && errors.lastName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mail*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="E-Mail eingeben"
                    type="email"
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.emailAddress && !errors.emailAddress}
                    isInvalid={touched.emailAddress && errors.emailAddress}
                    maxLength={settings.emailInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};